import { Stack } from "@mui/material";

export default function UpcomingReservations({children}) {
  return (
    <Stack width={{ xs: "100%", sm: "50%" }}>
      {children}
    </Stack>
  );
}